<div class="tool-bar">
  <div class="add-group-button-group" *ngIf="!loadingSpinner">
    <!--    <button class="add-group-button" mat-button (click)="addGroup()">New Group</button>-->
  </div>
</div>
<div class="item-groups">
  <ng-container *ngIf="!loadingSpinner">
    <div class="group-type" *ngFor="let grade of grades let i = index">
      <div class="group-type-title">
        <div class="grade-type">{{grade.type}}</div>
        <input class="arrow-input" type="text" pInputText BlockLateralArrowNavigation
               [ngModelOptions]="{standalone: true}" [(ngModel)]="grade.name"
               (ngModelChange)="changesMade(i)">
        <button class="default-button" [ngClass]="{'non-default': !grade.isDefault}" mat-button
                (click)="makeDefault(grade, i)">Default
        </button>
      </div>
      <div class="group-type-title">
        <input class="desc-input" type="text" pInputText BlockLateralArrowNavigation
               [ngModelOptions]="{standalone: true}" [(ngModel)]="grade.description" [placeholder]="'Description'"
               (ngModelChange)="changesMade(i)">
      </div>
      <div class="group-type-body">
        <p-table [value]="grade.prices" (onEditInit)="startEdit()"
                 (onEditComplete)="onEditComplete($event, i)">
          <ng-template pTemplate="header">
            <tr>
              <th class="name-cell">Name</th>
              <th>Cost QTY</th>
              <th>Cost LinFT</th>
              <th *ngIf="grade.type !== 'BOX'">Cost SQFT</th>
              <th *ngIf="grade.type !== 'BOX'">Install</th>
              <th *ngIf="grade.type !== 'BOX'">Delivery</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
            <tr>
              <td class="editable-cell name-cell">
                {{rowData.pricingCategory ? rowData.pricingCategory.name : 'DEFAULT'}}
              </td>
              <td pEditableColumn class="editable-cell price-cell">
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <input pInputText BlockLateralArrowNavigation type="tel" class="material-input-text"
                           [(ngModel)]="rowData.pricePerItem">
                  </ng-template>
                  <ng-template pTemplate="output">
                    <!-- {{roundNum(rowData.price)}} -->
                    ${{rowData.pricePerItem}}
                  </ng-template>
                </p-cellEditor>
              </td>
              <td pEditableColumn class="editable-cell price-cell">
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <input pInputText BlockLateralArrowNavigation type="tel" class="material-input-text"
                           [(ngModel)]="rowData.pricePerLinFT">
                  </ng-template>
                  <ng-template pTemplate="output">
                    ${{rowData.pricePerLinFT}}
                  </ng-template>
                </p-cellEditor>
              </td>
              <td pEditableColumn class="editable-cell price-cell" *ngIf="grade.type !== 'BOX'">
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <input pInputText BlockLateralArrowNavigation type="tel" class="material-input-text"
                           [(ngModel)]="rowData.pricePerSQFT">
                  </ng-template>
                  <ng-template pTemplate="output">
                    ${{rowData.pricePerSQFT}}
                  </ng-template>
                </p-cellEditor>
              </td>
              <td pEditableColumn class="editable-cell price-cell" *ngIf="grade.type !== 'BOX'">
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <input pInputText BlockLateralArrowNavigation type="tel" class="material-input-text"
                           [(ngModel)]="rowData.pricePerItemInstall">
                  </ng-template>
                  <ng-template pTemplate="output">
                    ${{rowData.pricePerItemInstall}}
                  </ng-template>
                </p-cellEditor>
              </td>
              <td pEditableColumn class="editable-cell price-cell" *ngIf="grade.type !== 'BOX'">
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <input pInputText BlockLateralArrowNavigation type="tel" class="material-input-text"
                           [(ngModel)]="rowData.pricePerItemDelivery">
                  </ng-template>
                  <ng-template pTemplate="output">
                    ${{rowData.pricePerItemDelivery}}
                  </ng-template>
                </p-cellEditor>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </ng-container>
</div>

<div class="loading-body" *ngIf="loadingSpinner">
  <lib-progress-spinner></lib-progress-spinner>
</div>

